import { render, staticRenderFns } from "./WorkSidebarList.vue?vue&type=template&id=3ced4864&scoped=true"
import script from "./WorkSidebarList.vue?vue&type=script&lang=js"
export * from "./WorkSidebarList.vue?vue&type=script&lang=js"
import style0 from "./WorkSidebarList.vue?vue&type=style&index=0&id=3ced4864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced4864",
  null
  
)

export default component.exports